import { render, staticRenderFns } from "./ClientImportModal.vue?vue&type=template&id=2aa544e8&scoped=true&"
import script from "./ClientImportModal.vue?vue&type=script&lang=js&"
export * from "./ClientImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientImportModal.vue?vue&type=style&index=0&id=2aa544e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa544e8",
  null
  
)

export default component.exports